import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'formatterPremierNumeroLotFournisseur'
})
export class FormatterPremierNumeroLotFournisseurPipe implements PipeTransform {

	transform(numerosLotsFournisseursAAfficher: any): string {
		if (numerosLotsFournisseursAAfficher) {
			const numerosLotsFournisseurs = numerosLotsFournisseursAAfficher.split(',');
			const premierNumeroLotFournisseur = numerosLotsFournisseurs[0];
			return numerosLotsFournisseurs.length === 1 ? premierNumeroLotFournisseur : premierNumeroLotFournisseur + '...';
		}
		return '';
	}

}
